import {useTranslation} from '@aboutyou/i18n';

export const useBICTranslations = () => {
  const {t} = useTranslation();
  const bicTranslations = {
    messages: {
      empty: t('Please provide your BIC/SWIFT code'),
      invalid: t(
        'Invalid BIC/SWIFT code (8 or 11 characters, uppercase letters and numbers only)',
      ),
    },
    placeholder: t('BIC/SWIFT'),
  };
  return bicTranslations;
};
